import React from "react";
import Nav from "../../components/Nav/Nav";
import { Helmet } from "react-helmet-async";
import "../About/About.css";

const siteUrl = "https://www.dore-avocat.fr";

function About(props) {
  return (
    <div>
      <Helmet>
        <title>À propos - Maître Camille Doré, avocate à Lille</title>
        <meta name="description" content="Découvrez le parcours de Maître Camille Doré, avocate au barreau de Lille engagée en droit des étrangers, fondatrice de l'association Pangéa et lauréate du Prodige de la République 2021." />
        <link rel="canonical" href={`${siteUrl}/apropos`} />
        <meta property="og:title" content="À propos - Maître Camille Doré, avocate à Lille" />
        <meta property="og:description" content="Découvrez le parcours de Maître Camille Doré, avocate au barreau de Lille engagée en droit des étrangers, fondatrice de l'association Pangéa et lauréate du Prodige de la République 2021." />
        <meta property="og:url" content={`${siteUrl}/apropos`} />
        <meta property="og:image" content={`${siteUrl}/images/camille_compress.jpg`} />
      </Helmet>
      <Nav />
      <div className="about-hero">
        <h1>À propos</h1>
      </div>
      <div className="intro">
        <div className="intro-photo">
          <img src="./images/camille_compress.jpg" alt="Maître Camille Doré, avocate spécialisée en droit des étrangers" />
        </div>
        <div className="intro-text">
          <p>Maître Camille Doré est avocate au Barreau de Lille. Titulaire d'un Master 2 en droit international, elle a obtenu le Certificat d'aptitude à la profession d'avocat (CAPA) en 2021.</p>
          <p>Avant de devenir avocate, elle s'est investie dans plusieurs associations œuvrant auprès des personnes étrangères et pour l'accès au droit. Ces expériences ont naturellement orienté son parcours professionnel et sa manière d'exercer.</p>
          <p>Après avoir exercé au sein de deux cabinets d'avocats, elle a créé son propre cabinet afin de proposer un accompagnement juridique clair et adapté à chaque situation.</p>
        </div>
      </div>
      <div className="engagement">
        <h2>Engagement associatif</h2>
        <div className="timeline">
          <div className="timeline-item">
            <div className="timeline-year">2016</div>
            <div className="timeline-content">
              <h3>Fondation de l'association Pangéa</h3>
              <p>En 2016, Maître Camille Doré a fondé l'association Pangéa, destinée à accompagner les personnes exilées souhaitant reprendre leurs études en France. Depuis sa création, l'association a accompagné plus de 600 étudiants grâce à la mobilisation de plus de 200 bénévoles.</p>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-year">2019</div>
            <div className="timeline-content">
              <h3>La Cimade</h3>
              <p>En 2019, elle a effectué son stage de fin d'études au sein de La Cimade à Perpignan. Cette expérience lui a permis d'approfondir sa connaissance du droit des étrangers et des problématiques juridiques liées aux frontières.</p>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-year">2020</div>
            <div className="timeline-content">
              <h3>Plateforme de soutien aux migrants</h3>
              <p>En 2020, elle a effectué un stage de six mois au sein de la Plateforme de soutien aux migrants à Calais. Elle a notamment travaillé sur les contentieux collectifs relatifs à la frontière franco-britannique au cours des dix années précédentes.</p>
            </div>
          </div>
        </div>
      </div>
      <div className="distinctions">
        <div className="distinctions-card">
          <h2>Distinctions</h2>
          <p>Son engagement associatif a été récompensé par le Prix de la Solidarité décerné à Pangéa par la Métropole Européenne de Lille et l'Université de Lille en 2019.</p>
          <p>En 2021, Maître Camille Doré a également reçu le titre de Prodige de la République.</p>
        </div>
      </div>
    </div>
  );
}

export default About;
